import React from 'react';
import { Icons } from '../icons/Icons';
import { SvgIcon } from '@mui/material';
import { useStyling } from '../Theme';

type ListViewConfigurationsProps = {
    onClick: () => void;
};

const ListViewConfigurations = ({ onClick }: ListViewConfigurationsProps) => {
    const { theme } = useStyling();

    return (
        <SvgIcon
            component={Icons.Configuration}
            sx={{ color: theme.palette.text.secondary, cursor: 'pointer' }}
            onClick={onClick}
        />
    );
};

export default ListViewConfigurations;
